export default __webpack_public_path__ + "static/media/FiguradoOpen.3c049953.jpg";